import React from 'react';
import { GeneratedImage } from '../types';
import { Eye, Wand2, Download } from 'lucide-react';

interface ImageGridProps {
  images: GeneratedImage[];
  index: string;
  onView: (img: GeneratedImage) => void;
  onEdit: (img: GeneratedImage) => void;
}

export const ImageGrid: React.FC<ImageGridProps> = ({ images, index, onView, onEdit }) => {
  return (
    // COMPACT UPDATE: Reduced padding to p-3
    <div className="p-3 bg-slate-950/50 border-t border-slate-800">
      <div className="grid gap-3 grid-cols-2 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 items-start">
        {images.map((img) => (
          <div key={img.id} className="group relative w-full bg-slate-800 rounded-lg overflow-hidden border border-slate-800 hover:border-indigo-500 transition-colors">
            <img src={img.url} alt="Generated" className="w-full h-auto object-contain cursor-pointer block" onClick={() => onView(img)} />
            <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-2 pointer-events-none">
               <div className="pointer-events-auto flex gap-2">
                <button onClick={() => onView(img)} className="p-2 bg-slate-800 text-white rounded-full hover:bg-slate-700 shadow-lg hover:scale-105 transition-all" title="查看">
                    <Eye size={16} />
                </button>
                <button onClick={() => onEdit(img)} className="p-2 bg-white text-slate-900 rounded-full hover:bg-indigo-50 hover:text-indigo-600 shadow-lg hover:scale-105 transition-all" title="AI 编辑">
                    <Wand2 size={16} />
                </button>
                <a href={img.url} download={`${index}_${img.id}.png`} className="p-2 bg-slate-900 text-white rounded-full hover:bg-black shadow-lg hover:scale-105 transition-all" title="下载">
                    <Download size={16} />
                </a>
               </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};